module.exports = __webpack_public_path__ + "static/media/daat.d53f1879.ogg";